import { jsx as t, Fragment as c, jsxs as p } from "react/jsx-runtime";
import s from "react";
import { p as n } from "../../index-B0ARwqly.mjs";
import { classes as e } from "../../utils/helpers.js";
import '../../assets/StringList.css';const l = {
  "string-list__pipe": "_string-list__pipe_6c2cm_1",
  "string-list--block": "_string-list--block_6c2cm_8"
};
function m({ list: g, separatorType: d = "comma", makeBlock: o = !1 }) {
  const a = g.filter((r) => !(r === "" || r === void 0 || r === null));
  if (a.length === 0) return /* @__PURE__ */ t(c, {});
  switch (d) {
    case "comma":
      return /* @__PURE__ */ t("span", { className: e(["string-list", o ? l["string-list--block"] : ""]), children: a.map((r, i) => i === 0 ? /* @__PURE__ */ t(s.Fragment, { children: typeof r == "string" ? n(r) : r }, `sl-${Math.round(Math.random() * 1e7)}`) : /* @__PURE__ */ p(s.Fragment, { children: [
        ", ",
        typeof r == "string" ? n(r) : r
      ] }, `sl-${Math.round(Math.random() * 1e7)}`)) });
    case "pipe":
      return /* @__PURE__ */ t("span", { className: e(["string-list", o ? l["string-list--block"] : ""]), children: a.map((r, i) => i === 0 ? /* @__PURE__ */ t(s.Fragment, { children: typeof r == "string" ? n(r) : r }, `sl-${Math.round(Math.random() * 1e7)}`) : /* @__PURE__ */ p(s.Fragment, { children: [
        /* @__PURE__ */ t("span", { className: e([l["string-list__pipe"], "string-list__pipe"]), children: " | " }),
        typeof r == "string" ? n(r) : r
      ] }, `sl-${Math.round(Math.random() * 1e7)}`)) });
    default:
      return /* @__PURE__ */ t(c, {});
  }
}
export {
  m as StringList,
  m as default
};
